import { PRINCIPES, FAQ_DEREF } from "@/data/dereferencement";

export const DerefFaqSection = () => {
  return (
    <section className="bg-[#F2F0ED] py-20 lg:py-28">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <ul className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-x-10 gap-y-10 mb-24">
          {PRINCIPES.map((p) => (
            <li key={p.t} className="border-l border-[#D8D3CD] pl-6 py-1">
              <h3 className="font-serif text-lg text-[#181A1D] font-normal mb-3">{p.t}</h3>
              <p className="text-[13px] text-[#666A70] font-normal leading-relaxed">{p.d}</p>
            </li>
          ))}
        </ul>
        <p className="label-eyebrow mb-6">Questions fréquentes</p>
        <h2 className="font-serif font-normal text-[#181A1D] text-3xl lg:text-4xl tracking-tight leading-[1.08] text-balance">
          Déréférencement Google : vos questions.
        </h2>
        <div className="mt-10 border-t border-[#E2DEDA] max-w-4xl" data-testid="deref-faq">
          {FAQ_DEREF.map((f, i) => (
            <details key={f.q} data-testid={`deref-faq-${i}`} className="border-b border-[#E2DEDA] py-6 lg:py-7 group">
              <summary className="font-serif text-lg lg:text-xl text-[#181A1D] font-normal cursor-pointer list-none flex justify-between items-baseline gap-4">
                {f.q}<span aria-hidden="true" className="text-[#8B8F95] group-open:rotate-45 transition-transform">+</span>
              </summary>
              <p className="mt-4 text-[14px] text-[#5A5E64] font-normal leading-relaxed text-pretty">{f.a}</p>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
};
